import { Disclaimer as SharedDisclaimer } from 'shared/components/Disclaimer';
import { useAppSelector } from 'shared/hooks/store';

import { ActionSection } from './components/ActionSection';
import { InformationSection } from './components/InformationSection';

export const Disclaimer = () => {
  const { enabled } = useAppSelector(state => state.parentHelper);

  if (enabled) {
    return null;
  }

  return (
    <SharedDisclaimer>
      <InformationSection />
      <ActionSection />
    </SharedDisclaimer>
  );
};
